import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  height: 100%;
  padding: 1.25rem;
`;

export const Wrapper = styled.div`
  display: flex;
  min-height: 400px;
  height: 100%;
  position: relative;
`;

export const VerticalTabs = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  border-right: 1px solid #dee2e6;
  margin: 2px;
  .nav {
    flex-direction: column;
  }

  .nav-link {
    margin-bottom: 2px;
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-bottom: 1px round #dee2e6;
    font-size: 14px;
    height: 100px;
    width: 40px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
  }

  .nav-link.active {
    background-color: #e9ecef;
    color: #57069e;
    border-radius: 5px;
  }

  .nav-link:hover {
    background-color: #e2e6ea;
  }

  .vertical-tab-content {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-rotated {
    transform: rotate(90deg);
    display: block;
    font-size: 18px;
  }

  .vertical-tab-content .label {
    font-size: 13px;
  }
`;

export const TabContent = styled.div`
  padding: 20px;
  height: 100%;
  width: 100%;
  flex: 1;
`;

export const ContainerCards = styled.div`
  display: flex;
  flex-direction: row;
  justify-self: flex-end;
  gap: 8px;
  width: 96%;
`;
